import ajax from "../../lib/appfuse-react/core/ajax";

const myCustomersService = {
    find: async () => {
        const response = await ajax.get('accounts/myCustomers');
        const data = response.data;
        data.totalElements = response.totalElements;
        return data;
    },
    switchUser: async (data) => {
        const response = await ajax.post('accounts/switchUser', data);
        return response.data;
    }
}

export default myCustomersService;